var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/Experience"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0005 18.0002V12.5612M12.0005 12.5612C12.5065 12.5616 13 12.5612 13.5005 12.5612M12.0005 12.5612C11.4945 12.5616 11 12.5612 10.5005 12.5612M14.2505 20.0392C12.7638 20.3216 11.2372 20.3216 9.7505 20.0392M13.5005 22.4222C12.5032 22.5266 11.4978 22.5266 10.5005 22.4222M14.2505 18.0002V17.8082C14.2505 16.8252 14.9085 15.9852 15.7585 15.4922C17.1865 14.6653 18.3019 13.3904 18.9319 11.8653C19.5619 10.3401 19.6713 8.64973 19.2432 7.05607C18.815 5.46241 17.8733 4.05444 16.5638 3.05031C15.2543 2.04618 13.6502 1.50195 12 1.50195C10.3498 1.50195 8.74573 2.04618 7.43624 3.05031C6.12675 4.05444 5.18497 5.46241 4.75683 7.05607C4.32869 8.64973 4.4381 10.3401 5.06809 11.8653C5.69809 13.3904 6.8135 14.6653 8.2415 15.4922C9.0915 15.9852 9.7505 16.8252 9.7505 17.8082V18.0002",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight);
export default __webpack_public_path__ + "static/media/icon-light.cff36880adcc3bf62236bf0f11ad66b6.svg";
export { ForwardRef as ReactComponent };